import { Alert } from '@gitbook/spine-react';

import { DocumentationLink } from '../Link';

export function OpenAPIComputedIncentiveAlert(props: { className?: string }) {
    return (
        <Alert
            className={props.className}
            kind="info"
            details={
                <>
                    You can use your OpenAPI spec to{' '}
                    <DocumentationLink path="creating-content/openapi">
                        generate a full self-updating API reference
                    </DocumentationLink>
                    .
                </>
            }
        />
    );
}
